import { trackServiceWorkerError } from "../services/analytics/analyticsEvents";
import { isMobileBuild } from "../services/platform/runtime";

export function registerServiceWorker(): void {
  if (isMobileBuild() || !("serviceWorker" in navigator) || !import.meta.env.PROD) {
    return;
  }
  const hadController = Boolean(navigator.serviceWorker.controller);
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController) {
      return;
    }
    if (refreshing) {
      return;
    }
    refreshing = true;
    window.location.reload();
  });
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).catch((error: unknown) => {
      console.warn("MoveInReport service worker registration failed.", error);
      trackServiceWorkerError(error);
    });
  });
}
